import { Component, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from 'app/helpers/formatDate';
import { sortCompare } from 'app/helpers/sortCompare';
import { InterestRegisterFacadeService } from 'app/services/api/interest-register/interest-register.service';
import { InterestRegisterEntryStatus, InterestRegisterListItem } from 'common/constants/assists-interest-register.constants';

@Component({
    selector: 'app-interest-register-list',
    templateUrl: './interest-register-list.component.html',
    styleUrls: ['./interest-register-list.component.scss'],
})
export class InterestRegisterListComponent implements OnInit {
    isLoading = true;
    isAdminList = false;

    displayedColumns: string[] = [];
    displayedData = new MatTableDataSource<InterestRegisterListItem>([]);

    InterestRegisterEntryStatus = InterestRegisterEntryStatus;

    constructor(
        private readonly facade: InterestRegisterFacadeService,
        private readonly router: Router,
        private readonly route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.isAdminList = this.router.url.includes('/skraningar') && !this.router.url.includes('/minar-skraningar');
        this.displayedColumns = this.isAdminList
            ? ['typeLabel', 'createdByName', 'createdDate', 'hasAttachments', 'status']
            : ['typeLabel', 'createdDate', 'hasAttachments', 'status'];

        this.fetchEntries();
    }

    fetchEntries(): void {
        this.isLoading = true;

        const request = this.isAdminList ? this.facade.listAllEntries() : this.facade.listMyEntries();

        request.subscribe({
            next: (entries) => {
                this.displayedData.data = entries;
                this.isLoading = false;
            },
            error: () => {
                this.displayedData.data = [];
                this.isLoading = false;
            },
        });
    }

    openEntry(entry: InterestRegisterListItem): void {
        this.router.navigate([entry.id], { relativeTo: this.route });
    }

    goBack(): void {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    formatDate(date: string): string {
        return formatDate(date);
    }

    getTitle(): string {
        return this.isAdminList ? 'Allar hagsmunaskráningar' : 'Mínar hagsmunaskráningar';
    }

    sortData(sort: Sort): void {
        const data = this.displayedData.data.slice();

        if (!sort.active || sort.direction === '') {
            this.displayedData.data = data;
            return;
        }

        this.displayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';

            switch (sort.active) {
                case 'typeLabel':
                    return sortCompare(a.typeLabel, b.typeLabel, isAsc);
                case 'createdByName':
                    return sortCompare(a.createdByName, b.createdByName, isAsc);
                case 'createdDate':
                    return sortCompare(a.createdDate, b.createdDate, isAsc);
                case 'status':
                    return sortCompare(a.status, b.status, isAsc);
                default:
                    return 0;
            }
        });
    }
}
